import { useState, useEffect, lazy, Suspense } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ArgumentsSection from "@/components/ArgumentsSection";
import CookieBanner from "@/components/CookieBanner";

// Below-fold sections lazy-loaded — reduces main-bundle and initial JS execution time
const GoldChartSection = lazy(() => import("@/components/GoldChartSection"));
const EventsSection = lazy(() => import("@/components/EventsSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const NewsletterSection = lazy(() => import("@/components/NewsletterSection"));
const PartnersSection = lazy(() => import("@/components/PartnersSection"));
const Footer = lazy(() => import("@/components/Footer"));

const SectionPlaceholder = () => <div className="h-32" aria-hidden="true" />;

export default function LandingPage() {
  const [cookieAccepted, setCookieAccepted] = useState(
    localStorage.getItem("cookie_accepted") === "true"
  );

  const handleAcceptCookies = () => {
    localStorage.setItem("cookie_accepted", "true");
    setCookieAccepted(true);
  };

  // Scroll to hash section when arriving from another page
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 500);
    }
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#0C1620]">
      <Header />
      <main>
        <HeroSection />
        <ArgumentsSection />
        <Suspense fallback={<SectionPlaceholder />}>
          <GoldChartSection />
          <EventsSection />
          <ContactSection />
          <NewsletterSection />
          <PartnersSection />
        </Suspense>
      </main>
      <Suspense fallback={<SectionPlaceholder />}>
        <Footer />
      </Suspense>
      {!cookieAccepted && <CookieBanner onAccept={handleAcceptCookies} />}
    </div>
  );
}
